import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children, apiBaseUrl }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const location = useLocation();

  const refreshAuth = useCallback(() => {
    fetch(`${apiBaseUrl}/user/roles`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setIsAuthenticated(data.roles.length > 0);
        setUserRoles(data.roles);
      })
      .catch(err => {
        console.error('Error fetching auth status:', err);
        setIsAuthenticated(false);
        setUserRoles([]);
      });
  }, [apiBaseUrl]);

  // Store the current location in localStorage if not on login/register page
  useEffect(() => {
    if (location.pathname !== '/login' && !location.pathname.startsWith('/register')) {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search + location.hash);
    }
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    refreshAuth(); // Initial check
  }, [refreshAuth]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, userRoles, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);